import { Component, Input, OnInit } from '@angular/core';
import {
  StringConst,
  BooleanCons,
  PaymentTypeInfo,
  TypeBBVAPayments,
} from '../../constants/const';

@Component({
  selector: 'app-payment-methods-image',
  templateUrl: './payment-methods-image.component.html',
  styleUrls: ['./payment-methods-image.component.scss'],
})
export class PaymentMethodsImageComponent implements OnInit {
  @Input() srcImage: string = StringConst.empty;
  @Input() paymentTypeCredit: string = StringConst.empty;
  @Input() isSmall = BooleanCons.false;
  @Input() isBig = BooleanCons.false;

  paymentTypeInfo = PaymentTypeInfo;

  constructor() { }

  ngOnInit(): void { }

  isBBVAPayment(): boolean {
    const bbvaPayments = [
      TypeBBVAPayments.digitalCheck,
      TypeBBVAPayments.branchPayment,
      TypeBBVAPayments.practiCaja,
      TypeBBVAPayments.interbankTransfer,
      TypeBBVAPayments.visaMastercard,
      TypeBBVAPayments.clabe,
      TypeBBVAPayments.amex,
      PaymentTypeInfo.bbvaMulti
    ];
    return bbvaPayments.some(typeBBVVA => this.srcImage.includes(typeBBVVA));
  }
}
